// extracted by mini-css-extract-plugin
export default {"headContainer":"products_headContainer__-hi9H","productsListContainer":"products_productsListContainer__vzk77"};